<template>
  <div class="flex items-center justify-end">
    <!-- Quick Actions (View/Edit) - Optional: always visible if preferred -->
    <div class="flex items-center gap-1 mr-2">
      <button
        v-if="showView"
        @click.stop="$emit('view', row)"
        class="p-2 text-slate-400 hover:text-primary hover:bg-primary/10 rounded-lg transition-all"
        :title="$t('view')"
      >
        <i class="fas fa-eye text-sm"></i>
      </button>
      <button
        v-if="showEdit"
        @click.stop="$emit('edit', row)"
        class="p-2 text-slate-400 hover:text-green-500 hover:bg-green-500/10 rounded-lg transition-all"
        :title="$t('edit')"
      >
        <i class="fas fa-edit text-sm"></i>
      </button>
    </div>

    <!-- Dropdown Actions Menu -->
    <div class="relative inline-block text-left" v-click-outside="closeMenu">
      <button
        ref="triggerBtn"
        @click.stop="toggleMenu"
        class="p-2 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-white/5 rounded-lg transition-all flex items-center justify-center"
      >
        <i class="fas fa-ellipsis-v"></i>
      </button>

      <!-- Dropdown Menu -->
      <Teleport to="body">
        <transition
          enter-active-class="transition duration-100 ease-out"
          enter-from-class="transform scale-95 opacity-0"
          enter-to-class="transform scale-100 opacity-100"
          leave-active-class="transition duration-75 ease-in"
          leave-from-class="transform scale-100 opacity-100"
          leave-to-class="transform scale-95 opacity-0"
        >
          <div
            v-if="isOpen"
            @click.stop
            class="fixed w-48 origin-top-right bg-white dark:bg-dark-surface border border-slate-200 dark:border-white/10 rounded-xl shadow-xl overflow-hidden py-1"
            :style="{ ...menuPosition, zIndex: 99999 }"
          >
            <!-- Slots for dynamic actions -->
            <div class="contents" @click="closeMenu">
              <slot name="before" :row="row"></slot>
            </div>

            <!-- Computed default actions -->
            <button
              v-if="showDelete"
              @click.stop="handleAction('delete')"
              class="w-full flex items-center gap-3 px-4 py-2.5 text-xs font-bold text-red-500 hover:bg-red-50 dark:hover:bg-red-500/5 transition-colors"
            >
              <i class="fas fa-trash-alt w-4"></i>
              {{ $t("delete") }}
            </button>

            <!-- After Slot -->
            <div class="contents" @click="closeMenu">
              <slot name="after" :row="row"></slot>
            </div>
          </div>
        </transition>
      </Teleport>
    </div>
  </div>
</template>

<script>
export default {
  name: "TableActions",
  props: {
    row: { type: Object, default: () => ({}) },
    showView: { type: Boolean, default: false },
    showEdit: { type: Boolean, default: false },
    showDelete: { type: Boolean, default: false },
  },
  data() {
    return {
      isOpen: false,
      menuPosition: {},
    };
  },
  directives: {
    "click-outside": {
      beforeMount(el, binding) {
        el.clickOutsideEvent = (event) => {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value();
          }
        };
        document.addEventListener("click", el.clickOutsideEvent);
      },
      unmounted(el) {
        document.removeEventListener("click", el.clickOutsideEvent);
      },
    },
  },
  methods: {
    toggleMenu() {
      console.log("toggleMenu called, isOpen before:", this.isOpen);
      this.isOpen = !this.isOpen;
      console.log("isOpen after:", this.isOpen);
      if (this.isOpen) {
        this.$nextTick(this.calculatePosition);
      }
    },
    calculatePosition() {
      const rect = this.$refs.triggerBtn.getBoundingClientRect();
      const menuWidth = 192;
      this.menuPosition = {
        top: `${rect.bottom + window.scrollY + 8}px`,
        left: `${rect.right - menuWidth + window.scrollX}px`,
      };
    },
    closeMenu() {
      this.isOpen = false;
    },
    handleAction(action) {
      this.$emit(action, this.row);
      this.closeMenu();
    },
  },
};
</script>

<style scoped>
/* Ensure slot buttons match the dropdown item style */
:deep(button) {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.75rem; /* gap-3 */
  padding: 0.625rem 1rem; /* py-2.5 px-4 */
  text-align: left;
  transition-property: color, background-color;
  transition-duration: 200ms;
}

:deep(button:hover) {
  background-color: rgba(0, 0, 0, 0.05);
}

.dark :deep(button:hover) {
  background-color: rgba(255, 255, 255, 0.05);
}

/* Specific adjustments for icons in buttons from slots */
:deep(button i) {
  width: 1rem; /* w-4 */
  text-align: center;
}
</style>
